export default __webpack_public_path__ + "static/media/configs.9d1ce8fa.svg";